import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TReportsStore } from './types';

export const getReportsState = (state: TStoreState): TReportsStore => state.reports;

export const getReportTypes = createSelector(
	[getReportsState],
	(reports: TReportsStore) => reports.reportTypes,
);

export const getReportTypesLoading = createSelector(
	[getReportsState],
	(reports: TReportsStore) => reports.reportTypesLoading,
);

export const getAvailableReports = createSelector(
	[getReportsState],
	(reports: TReportsStore) => reports.availableReports,
);

export const getAvailableReportsLoading = createSelector(
	[getReportsState],
	(reports: TReportsStore) => reports.availableReportsLoading,
);

export const getDownloadingReportIds = createSelector(
	[getReportsState],
	(reports: TReportsStore) => reports.downloadingReportIds,
);
